<button (click)="cancel()" class="goback">
    <i class="bi bi-arrow-left"></i> Back to Users List
</button>

<div class="content-info">
    <div class="content-title d-flex justify-content-between align-items-center">
        <h3 class="title">{{ isEdit ? 'Edit User' : 'Create New User' }}</h3>
        <div class="title-actions">
            <button type="button" class="btn btnsecondary" (click)="cancel()">
                Cancel
            </button>
            <button type="button" class="btn btnprimary" (click)="submit()" [disabled]="userForm.invalid">
                {{ isEdit ? 'Update' : 'Create' }}
            </button>
        </div>
    </div>

    <form [formGroup]="userForm" (ngSubmit)="submit()">
        <div class="row g-3 mb-3">
            <div class="col-md-2 col-sm-6">
                <label class="form-label">Username</label>
                <input type="text" formControlName="username" class="form-control" placeholder="e.g., john_doe" />
            </div>



            <div class="col-md-2 col-sm-6">
                <label class="form-label">Password {{ isEdit ? '(optional)' : '' }}</label>
                <div class="input-group">
                    <input [type]="show.password ? 'text' : 'password'" formControlName="password" class="form-control"
                        autocomplete="new-password" [placeholder]="isEdit ? 'Leave blank to keep current' : ''" />
                    <button class="btn btn-outline-secondary" type="button" (click)="toggle('password')"
                        [attr.aria-label]="show.password ? 'Hide password' : 'Show password'"
                        [attr.aria-pressed]="show.password">
                        <i class="bi" [ngClass]="show.password ? 'bi-eye-slash' : 'bi-eye'"></i>
                    </button>
                </div>
                @if (userForm.get('password')?.invalid && userForm.get('password')?.touched) {
                <small class="text-danger">Password is required</small>
                }
                @if (userForm.errors?.['passwordRequired'] && userForm.get('password')?.touched) {
                <small class="text-danger">Password is required</small>
                }
            </div>

            <div class="col-md-2 col-sm-6">
                <label class="form-label">Confirm Password</label>
                <div class="input-group">
                    <input [type]="show.confirm ? 'text' : 'password'" formControlName="confirmPassword"
                        class="form-control" autocomplete="new-password"
                        [placeholder]="isEdit ? 'Leave blank to keep current' : ''" />
                    <button class="btn btn-outline-secondary" type="button" (click)="toggle('confirm')"
                        [attr.aria-label]="show.confirm ? 'Hide confirmation' : 'Show confirmation'"
                        [attr.aria-pressed]="show.confirm">
                        <i class="bi" [ngClass]="show.confirm ? 'bi-eye-slash' : 'bi-eye'"></i>
                    </button>
                </div>
                @if (userForm.get('confirmPassword')?.invalid && userForm.get('confirmPassword')?.touched) {
                <small class="text-danger">Confirm Password is required</small>
                }
                @if (userForm.errors?.['confirmPasswordRequired'] && userForm.get('confirmPassword')?.touched) {
                <small class="text-danger">Confirm Password is required</small>
                }
                @if (userForm.errors?.['passwordMismatch'] && userForm.get('confirmPassword')?.touched) {
                <small class="text-danger">Passwords do not match</small>
                }
            </div>

            <div class="col-md-2 col-sm-6">
                <label class="form-label">PIN {{ isEdit ? '(optional)' : '' }}</label>
                <div class="input-group">
                    <input [type]="show.pin ? 'text' : 'password'" formControlName="pin" class="form-control"
                        autocomplete="off" inputmode="numeric" maxlength="4"
                        [placeholder]="isEdit ? 'Leave blank to keep current' : 'e.g., 1234'" />
                    <button class="btn btn-outline-secondary" type="button" (click)="toggle('pin')"
                        [attr.aria-label]="show.pin ? 'Hide PIN' : 'Show PIN'" [attr.aria-pressed]="show.pin">
                        <i class="bi" [ngClass]="show.pin ? 'bi-eye-slash' : 'bi-eye'"></i>
                    </button>
                </div>
            </div>

            <div class="col-md-2 col-sm-6">
                <label class="form-label">Name</label>
                <input type="text" formControlName="name" class="form-control" placeholder="e.g., John Doe" />
            </div>
            <div class="col-md-4 col-sm-6">
                <label class="form-label">Email</label>
                <input type="email" formControlName="email" class="form-control" placeholder="e.g., john@example.com" />
            </div>

            <div class="col-md-2 col-sm-6">
                <label class="form-label">Mobile</label>
                <input type="text" formControlName="mobile" class="form-control" placeholder="e.g., 9876543210" />
            </div>

            <div class="col-md-2 col-sm-12">
                <label class="form-label">Select Role</label>
                <ng-select [items]="roles" bindLabel="name" bindValue="id" [multiple]="true"
                    [closeOnSelect]="false" formControlName="roleIds" placeholder="Select Roles">
                </ng-select>
            </div>

            <div class="col-md-2 col-sm-12">
                <label class="form-label">Select Store</label>
                <ng-select [items]="stores" bindLabel="name" bindValue="id" [multiple]="true" formControlName="storeIds"
                    placeholder="Select Stores">
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.location || item.name }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.location || item.name }}
                    </ng-template>
                </ng-select>
            </div>

            <!-- Active Status Toggle -->
            <div class="col-md-2 col-sm-6 d-flex align-items-end">
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" role="switch" id="isActiveSwitch"
                        formControlName="isActive" [ngClass]="{'bg-success': userForm.get('isActive')?.value}" />
                    <label class="form-check-label fw-bold ms-2" for="isActiveSwitch"
                        [ngClass]="userForm.get('isActive')?.value ? 'text-success' : 'text-secondary'">
                        {{ userForm.get('isActive')?.value ? 'ACTIVE' : 'INACTIVE' }}
                    </label>
                </div>
            </div>

            <!-- Client ID is auto-populated and hidden -->
            <input type="hidden" formControlName="clientId" />


        </div>
    </form>
</div>